import React, { useState } from 'react';
import { Pie } from 'react-chartjs-2';

interface PerformanceRecord {
  c1D: string;
  c1J: string;
  c1S: string;
  c26: number;
}

interface Props {
  records: PerformanceRecord[];
  colors: string[];
}

const C1DrilldownPieChart: React.FC<Props> = ({ records, colors }) => {
  const [level, setLevel] = useState<'c1D' | 'c1J' | 'c1S'>('c1D');
  const [parent, setParent] = useState<string | undefined>(undefined);

  let labels: string[] = [];
  let values: number[] = [];
  let title = '1차 대분류별 매출';

  if (level === 'c1D') {
    const map: Record<string, number> = {};
    records.forEach(rec => {
      if (rec.c1D) map[rec.c1D] = (map[rec.c1D] || 0) + rec.c26;
    });
    labels = Object.keys(map);
    values = Object.values(map);
    title = '1차 대분류별 매출';
  } else if (level === 'c1J' && parent) {
    const map: Record<string, number> = {};
    records.filter(rec => rec.c1D === parent).forEach(rec => {
      if (rec.c1J) map[rec.c1J] = (map[rec.c1J] || 0) + rec.c26;
    });
    labels = Object.keys(map);
    values = Object.values(map);
    title = `1차 중분류별 매출 - ${parent}`;
  } else if (level === 'c1S' && parent) {
    const map: Record<string, number> = {};
    records.filter(rec => rec.c1J === parent).forEach(rec => {
      if (rec.c1S) map[rec.c1S] = (map[rec.c1S] || 0) + rec.c26;
    });
    labels = Object.keys(map);
    values = Object.values(map);
    title = `1차 소분류별 매출 - ${parent}`;
  }

  const handlePieClick = (evt: any, elements: any[]) => {
    if (!elements || elements.length === 0) return;
    const idx = elements[0].index;
    if (level === 'c1D') {
      setLevel('c1J');
      setParent(labels[idx]);
    } else if (level === 'c1J') {
      setLevel('c1S');
      setParent(labels[idx]);
    }
  };

  const handleBack = () => {
    if (level === 'c1S' && parent) {
      const parentJ = records.find(rec => rec.c1S === parent)?.c1J;
      setLevel('c1J');
      setParent(parentJ);
    } else if (level === 'c1J') {
      setLevel('c1D');
      setParent(undefined);
    }
  };

  return (
    <div className="drilldown-box">
      <h2>
        {title}
        {level !== 'c1D' && (
        <button onClick={handleBack}>◀</button>
        )}
      </h2>
      <div className="chart pie-chart">
        <Pie
          data={{
            labels,
            datasets: [
              {
                data: values,
                backgroundColor: labels.map((_, i) => colors[i % colors.length]),
              },
            ],
          }}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: { display: true },
              title: { display: false },
              tooltip: {
                callbacks: {
                  label: function(context) {
                    const value = context.parsed;
                    return `${context.label}: ${value.toLocaleString()}원`;
                  }
                }
              }
            },
            onClick: handlePieClick,
          }}
          height={300}
        />
      </div>
    </div>
  );
};

export default C1DrilldownPieChart; 